import { render, staticRenderFns } from "./TagsMultiselect.vue?vue&type=template&id=8a3278ba"
import script from "./TagsMultiselect.vue?vue&type=script&lang=ts"
export * from "./TagsMultiselect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a3278ba')) {
      api.createRecord('8a3278ba', component.options)
    } else {
      api.reload('8a3278ba', component.options)
    }
    module.hot.accept("./TagsMultiselect.vue?vue&type=template&id=8a3278ba", function () {
      api.rerender('8a3278ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/TagsMultiselect.vue"
export default component.exports